import { Button } from "primereact/button";
import "./CustomButton.scss";
interface ButtonProps {
	label: string;
	iconsOnly: boolean;
	icon?: string;
	iconPosition?: "left" | "top" | "bottom" | "right";
	onClick: () => void;
	disabled?: boolean;
	className?: string;
	variant?: "primary" | "secondary" | "tertiary" | "outlined";
	loadingProp?: boolean;
}
const CustomButton: React.FC<ButtonProps> = ({
	label,
	iconsOnly = false,
	icon,
	iconPosition = "left",
	variant = "primary",
	onClick,
	className = "",
	loadingProp = false,
	...rest
}) => {
	const variantClasses = variant + "class";

	return (
		<Button
			label={iconsOnly ? undefined : label}
			icon={icon}
			iconPos={iconPosition}
			aria-label={iconsOnly ? label : undefined}
			onClick={onClick}
			loading={loadingProp}
			className={`${variantClasses} ${className}`.trim()}
			{...rest}
		/>
	);
};

export default CustomButton;
